import { atom, selector } from 'recoil';

const companyState = atom({
    key: 'companyState',
    default: {
        company_logo: {},
        pageImages: [],
        company_address: '',
        phone_number: '',
    }
});

export {
    companyState
}